
import { required } from 'vuelidate/lib/validators'

export default {
  credentials: {
    current_password: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/disabled-account/resources/validations.js